<template>
  <v-container class="scheduling-content" fluid>

    <CompromiseCalendar
      ref="CompromiseCalendar"
      @newAppointment="newAppointment"
      @editAppointment="editAppointment"
    />

    <ModalManageCompromise
      :isActive="isModalManageCompromiseActive"
      :data="compromise"
      @close="closeModalManageCompromise"
      @save="appointmentCreated"
      @edit="appointmentUpdated"
    />

  </v-container>
</template>

<script>
import CompromiseCalendar from '@/components/Schedule/Calendar/Main';
import ModalManageCompromise from '@/components/Schedule/ModalManageCompromise';

export default {
  components: {
    ModalManageCompromise,
    CompromiseCalendar
  },
  data () {
    return {
      isLoading: false,
      isModalManageCompromiseActive: false,
      picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      pickerDate: null,
      compromise: {
        day: null,
      },
    }
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0,0);
    }, 100);
  },
  methods: {
    appointmentCreated(appointment) {
      this.$refs.CompromiseCalendar.addAppointment(appointment);

      this.isModalManageCompromiseActive = false;
    },
    appointmentUpdated(appointment) {
      this.$refs.CompromiseCalendar.updateAppointment(appointment);

      this.isModalManageCompromiseActive = false;
    },
    newAppointment(day) {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      day = `${day} ${hours}:${minutes}`;

      this.compromise = {
        forecast: day,
      };

      this.isModalManageCompromiseActive = true;
    },
    editAppointment(appointment) {
      this.compromise = JSON.parse(JSON.stringify(appointment));

      this.isModalManageCompromiseActive = true;
    },
    selectDate(e) {
      console.log(e)
    },
    resetCalendar() {
      this.picker = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    },
    closeModalManageCompromise() {
      this.isModalManageCompromiseActive = false;
    },
  },
  watch: {
    pickerDate (e) {
      console.log(e)
    },
  },
}
</script>

<style lang="scss">
.scheduling-content {
  padding: 0px;
  padding-bottom: 90px!important;

  .header {
    padding: 20px 20px;
    background-color: #EEEEEE;
  }
}

#checkmotors-schedule {
  .v-date-picker-table, .v-date-picker-header {
    background-color: #F5F5F5;
  }

  .v-date-picker-table--date .v-btn {
    height: 38px !important;
    width: 50px !important;
  }

  .v-date-picker-table--date .v-date-picker-table__events {
    bottom: 8px !important;
  }
}

.scheduling {
  width: 100%;
  margin-top: 12px;

  .group {
    border: 1px solid #cdcdcd;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 15px;

    &.confirmed {
      border-color: #3b9674;

      .g-title {
        color: #3b9674;
        border-color: #3b9674;
      }

      .g-content .scheduled {
        border-color: #3b9674;

        .details {
          background-color: #48B38B;
          border-color: #3b9674;

          .name {
            color: #fff;
          }

          .vehicle {
            color: #f1f1f1;
          }
        }
      }
    }

    &.canceled {
      border-color: #ce762d;

      .g-title {
        color: #ce762d;
        border-color: #ce762d;
      }

      .g-content .scheduled {
        border-color: #ce762d;

        .details {
          background-color: #ed8936;
          border-color: #ce762d;

          .name {
            color: #fff;
          }

          .vehicle {
            color: #f1f1f1;
          }
        }
      }
    }

    .g-title {
      width: 100%;
      border-bottom: 1px solid #cdcdcd;
      margin-bottom: 10px;
      padding-bottom: 5px;
      color: #666666;
      font-weight: bold;
      font-size: 1.2rem;
    }

    .g-content {

      .scheduled {
        overflow: hidden;
        border: 1px solid #cdcdcd;
        border-left: 3px solid #cdcdcd;
        border-radius: 5px;
        margin-bottom: 10px;

        .header {
          float: left;
          padding: 13px 10px;
          width: 115px;

          .plate {
            height: 31px;
            float: right;

            img {
              height: 31px;
            }
          }
        }

        .details {
          float: left;
          overflow: hidden;
          line-height: 23px;
          padding: 6px 10px;
          width: calc(100% - 115px);
          background-color: #F5F5F5;
          border-left: 1px solid #cdcdcd;

          .name {
            font-size: 1.2rem !important;
            color: rgba(0, 0, 0, 0.87);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .vehicle {
            color: rgba(0, 0, 0, 0.61);
            font-size: .875rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
